import React from "react";
import { ResultOf } from "gql.tada";
import { GetEditorialPageById } from "@queries/archetypes/GetEditorialPageById";
import { Hero } from "@components/entries/Hero";
import { TitleSection } from "@components/entries/TitleSection";
import { StillWatchingTitleSection } from "@components/entries/TitleSection/StillWatchingTitleSection";
import { DescriptionFillSection } from "@components/entries/DescriptionFillSection";
import { StillWatchingDescriptionFillSection } from "@components/entries/DescriptionFillSection/StillWatchingDescriptionFillSection";
import { ListSection } from "@components/entries/ListSection";
import { RoutingSection } from "@components/entries/RoutingSection";
import {
  EditorialSectionKey,
  getEditorialPageConfig,
} from "./editorialPageConfig";

type EditorialPageData = NonNullable<
  ResultOf<typeof GetEditorialPageById>["editorialPage"]
>;

export const EditorialPageRenderer = ({
  data,
}: {
  data: EditorialPageData;
}) => {
  const config = getEditorialPageConfig(data.slug);

  const sectionRenderers: Record<
    EditorialSectionKey,
    React.ReactNode | null
  > = {
    hero: data.hero ? (
      <Hero entry={{ hero: data.hero } as any} />
    ) : null,
    sectionTitle: data.sectionTitle ? (
      config.useStillWatchingVariants ? (
        <StillWatchingTitleSection
          entry={{ titleSection: data.sectionTitle } as any}
        />
      ) : (
        <TitleSection
          entry={{ titleSection: data.sectionTitle } as any}
        />
      )
    ) : null,
    description: data.description ? (
      config.useStillWatchingVariants ? (
        <StillWatchingDescriptionFillSection
          entry={{ descriptionFillSection: data.description } as any}
        />
      ) : (
        <DescriptionFillSection
          entry={{ descriptionFillSection: data.description } as any}
        />
      )
    ) : null,
    list: data.list ? (
      <ListSection entry={{ listSection: data.list } as any} />
    ) : null,
    routing: data.routing ? (
      <RoutingSection
        entry={{ routingSection: data.routing } as any}
      />
    ) : null,
  };

  return (
    <>
      {config.sectionOrder.map((key) => (
        <React.Fragment key={key}>{sectionRenderers[key]}</React.Fragment>
      ))}
    </>
  );
};
